import { ApolloLink } from '@apollo/client';
import createHttpHeadersLink from './links/createHttpHeadersLink';
import createTerminatingLink from './links/createTerminatingLink';
import createExtensionsLink from './links/createExtensionsLink';
import wrapFetchWithErrors from './errors/wrapFetchWithErrors';
import wrapFetchWithNormalizeHeaders from './wrapFetchWithNormalizeHeaders';
export default function createV2ApolloLink(fetch, routeThroughEdge) {
    const fetchWithErrors = wrapFetchWithErrors(fetch);
    const wrappedFetch = wrapFetchWithNormalizeHeaders(fetchWithErrors);
    return ApolloLink.from([
        createExtensionsLink(),
        createHttpHeadersLink(routeThroughEdge),
        createTerminatingLink(routeThroughEdge, wrappedFetch)
    ]);
}

//# sourceMappingURL=createV2ApolloLink.js.map